import {
  setIsPackagesLoading,
  setPackageDataBeenFetched,
  setPackageList,
  setPackagesFilters,
  setPackageSummeryData,
  setQueryBizLayerData,
} from "../../../features/monitoringPackagesSlice";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { monitoringPackagesService } from "../../../services/api/monitoring-packages.endpoints";

// async function getAllPackageList(oauthTokenHeader: any,from_date: any, to_date: any, dispatch: any) {
//   try {
//     const response = await monitoringPackagesService.getAllPackages(
//       oauthTokenHeader,
//       from_date,
//       to_date
//     );
//     if (!response || !response.status) {
//       throw new Error("Failed to access packages");
//     } else if(response.status === 200) {
//       const uniquePackages = [...new Set(response?.data?.data?.valid_records)];
//       dispatch(setPackageList(uniquePackages)); // Set the packaged list
//       return response?.data;
//     }
//   } catch (e: any) {
//     return e ? e?.parsedText : {reason : "Unknown error occurred."};
//   }
// }

async function getAllPackageList(
  oauthTokenHeader: any,
  from_date: any,
  to_date: any,
  dispatch: any,
  rpp?: any,
  page?: any,
  previousList: any[] = [],
  filters?: {
    status?: string[];
    run_method?: string[];
    step?: string[];
    process_id?: string[]; // Changed from process_name to process_id
    package_name?: string[];
    brand_id?: string[];
    interface_id?: string[];
    workflow_name?: string[];
  }
) {
  try {
    const cleanedFilters = filters
      ? Object.fromEntries(
          Object.entries(filters).filter(
            ([_, value]) =>
              value !== undefined &&
              value !== null &&
              (Array.isArray(value) ? value.length > 0 : true)
          )
        )
      : undefined;
    const response = await monitoringPackagesService.getAllPackages(
      oauthTokenHeader,
      from_date,
      to_date,
      rpp,
      page,
      cleanedFilters
    );
    if (!response || !response.status) {
      dispatch(setPackageList([]));
      dispatch(setPackageSummeryData([]));
      dispatch(setPackageDataBeenFetched(true));
      throw new Error("Failed to access packages");
    } else if (response.status === 200) {
      const uniquePackages = [...new Set(response?.data?.data?.valid_records)];
      const summaries = response?.data?.data?.summaries;
      let finalList;
      if (Array.isArray(previousList) && previousList.length > 0) {
        finalList = [...previousList, ...uniquePackages];
      } else {
        finalList = uniquePackages;
      }

      dispatch(setPackageList(finalList)); // Set the packaged list
      dispatch(setPackageSummeryData(summaries)); // set the package summary data
      dispatch(setPackageDataBeenFetched(true)); // Set package data fetched true
      return response?.data;
    }
  } catch (e: any) {
    dispatch(setPackageList([]));
    dispatch(setPackageSummeryData([]));
    dispatch(setPackageDataBeenFetched(true));
    dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred.",
        type: "error",
      })
    );
    return e ? e?.parsedText : { reason: "Unknown error occurred." };
  }
}
async function getPackagesSummery(
  oauthTokenHeader: any,
  from_date: any,
  to_date: any,
  dispatch: any
) {
  try {
    const response = await monitoringPackagesService.getPackageSummeryData(
      oauthTokenHeader,
      from_date,
      to_date
    );
    if (!response || !response.status) {
      throw new Error("Failed to access packages data summery");
    } else if (response.status === 200) {
      dispatch(setPackageSummeryData(response?.data?.data?.valid_records)); // Set the packaged summery data
      return response?.data;
    }
  } catch (e: any) {
    return e ? e?.parsedText : { reason: "Unknown error occurred." };
  }
}

async function getQueryBizLayer(
  oauthTokenHeader: any,
  query_id: any,
  website_shared_uid: any,
  from_date: any,
  to_date: any,
  dispatch: any
) {
  try {
    const response = await monitoringPackagesService.getQueryBizLayerData(
      oauthTokenHeader,
      query_id,
      website_shared_uid,
      from_date,
      to_date
    );
    if (!response || !response.status) {
      throw new Error("Failed to access interface and brand data");
    } else if (response.status === 200) {
      dispatch(setQueryBizLayerData(response?.data?.data?.query_output)); // Set the packaged summery data
      return response?.data;
    }
  } catch (e: any) {
    return e ? e?.parsedText : { reason: "Unknown error occurred." };
  }
}
async function getAllFilters(
  oauthTokenHeader: Record<string, string>,
  filters: string[],
  dispatch: (action: any) => void
): Promise<void | { reason: string }> {
  try {
    dispatch(setIsPackagesLoading(true));
    const response = await monitoringPackagesService.getAllFiltersInParallel(
      filters,
      oauthTokenHeader
    );

    if (!response?.status || !response.data) {
      return { reason: "Failed to retrieve filters." };
    }

    dispatch(setPackagesFilters(response.data?.data));
  } catch (error: any) {
    const reason =
      error?.parsedText?.reason ?? error?.message ?? "Unknown error occurred.";
    return { reason };
  } finally {
    dispatch(setIsPackagesLoading(false));
  }
}
export const PackagesEndPointLogic = {
  getAllPackageList,
  getPackagesSummery,
  getQueryBizLayer,
  getAllFilters,
};
